import { addComment } from "src/commentView/actions";
import { createEntity } from "src/createEntityModal/actions";
import {
  deleteSpread,
  loadBriefSpreads,
  reloadBriefSpreads
} from "src/documentList/actions";
import { getEntities } from "src/entityList/actions";
import { editEntity } from "src/entityView/actions";
import { login, resetPassword } from "src/login/actions";
import { getMetadataConfig, updateSpreadMetadata } from "src/metadata/actions";
import {
  changeSpreadState,
  mapUnmappedAccount,
  rejectSpread,
  remapAccount,
  tagAccount,
  undoRule,
  unlockSpread,
  unmapHiddenAccountRow,
  updateAccount
} from "src/spread/model/spread/actions";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { resetRequestProgress } from "./actions";

export enum STATES {
  ERROR = "error",
  INITIAL = "initial",
  LOADED = "loaded",
  LOADING = "loading"
}

export enum actions {
  changeSpreadState = "changeSpreadState",
  loadBriefSpreads = "loadBriefSpreads",
  login = "login",
  unlockSpread = "unlockSpread",
  deleteSpread = "deleteSpread",
  reloadBriefSpreads = "reloadBriefSpreads",
  createEntity = "createEntity",
  getEntities = "getEntities",
  editEntity = "editEntity",
  updateAccount = "updateAccount",
  unmapHiddenAccountRow = "unmapHiddenAccountRow",
  remapAccount = "remapAccount",
  mapUnmappedAccount = "mapUnmappedAccount",
  undoRule = "undoRule",
  addComment = "addComment",
  getMetadataConfig = "getMetadataConfig",
  updateSpreadMetadata = "updateSpreadMetadata",
  resetPassword = "resetPassword",
  tagAccount = "tagAccount",
  rejectSpread = "rejectSpread"
}

export const actionFns = {
  changeSpreadState,
  loadBriefSpreads,
  login,
  unlockSpread,
  deleteSpread,
  reloadBriefSpreads,
  createEntity,
  getEntities,
  editEntity,
  updateAccount,
  unmapHiddenAccountRow,
  remapAccount,
  mapUnmappedAccount,
  undoRule,
  addComment,
  getMetadataConfig,
  updateSpreadMetadata,
  resetPassword,
  tagAccount,
  rejectSpread
};

export type RequestProgressState = {
  [k in actions]?:
    | STATES.INITIAL
    | STATES.LOADING
    | STATES.LOADED
    | STATES.ERROR;
};

const initialState = {};

const requestProgressReducer = reducerWithInitialState<
  Readonly<RequestProgressState>
>(initialState);

Object.keys(actionFns).map(actionName => {
  requestProgressReducer
    .case(actionFns[actionName].async.started, state => {
      return { ...state, [actionName]: STATES.LOADING };
    })
    .case(actionFns[actionName].async.done, state => {
      return { ...state, [actionName]: STATES.LOADED };
    })
    .case(actionFns[actionName].async.failed, state => {
      return { ...state, [actionName]: STATES.ERROR };
    })
    .case(resetRequestProgress, (state, actionNameToReset) => {
      return { ...state, [actionNameToReset]: STATES.INITIAL };
    });
});

export default requestProgressReducer;



// WEBPACK FOOTER //
// ./src/requestProgress/reducer.ts